import * as fb from "../../firebase";
import moment from "moment";
import axios from "axios";
export default {
  state: {
    selectedKioskAnalytics: null,
    selectedDuration: "Today",
    displayDate: "",
    todayBarChart: [
      { category: "8 AM", value: 0 },
      { category: "9 AM", value: 0 },
      { category: "10 AM", value: 0 },
      { category: "11 AM", value: 0 },
      { category: "12 PM", value: 0 },
      { category: "1 PM", value: 0 },
      { category: "2 PM", value: 0 },
      { category: "3 PM", value: 0 },
      { category: "4 PM", value: 0 },
      { category: "5 PM", value: 0 },
    ],
    pieChart: [
      { label: "Faqs", value: 0 },
      { label: "Maps", value: 0 },
      { label: "Forms", value: 0 },
      { label: "Payments", value: 0 },
      { label: "Hearings", value: 0 },
    ],
    languageBarChart: [
      { category: "English", value: 0 },
      { category: "Spanish", value: 0 },
    ],
    pieChartTotal: 0,
    singleDatePicker: false,
    selectedSingleDate: null,
    weekDatePicker: false,
    selectedWeekDate: null,
    fiscalYearPicker: false,
    enteredFiscalYear: "",
    closeWithoutSelection: 0,
    yearPicker: false,
    enteredYear: "",

    // Analytics Newer version
    totalSessions: 0,
    totalInterations: 0,
    modulesCount: {},
    sessionList: [],
    sessionDuration: {},
    qnaList: [],
    languageCount: {},
  },
  getters: {
    getSelectedKioskAnalytics: (state) => state.selectedKioskAnalytics,
    todayBarChart: (state) => state.todayBarChart,
    pieChart: (state) => state.pieChart,
    getPieChartTotal: (state) => state.pieChartTotal,
    languageBarChart: (state) => state.languageBarChart,
    selectedDuration: (state) => state.selectedDuration,
    singleDatePicker: (state) => state.singleDatePicker,
    selectedSingleDate: (state) => state.selectedSingleDate,
    weekDatePicker: (state) => state.weekDatePicker,
    selectedWeekDate: (state) => state.selectedWeekDate,
    displayDate: (state) => state.displayDate,
    fiscalYearPicker: (state) => state.fiscalYearPicker,
    enteredFiscalYear: (state) => state.enteredFiscalYear,
    closeWithoutSelection: (state) => state.closeWithoutSelection,
    yearPicker: (state) => state.yearPicker,
    enteredYear: (state) => state.enteredYear,

    // Analytics Newer version
    getTotalSessions: (state) => state.totalSessions,
    getTotalInterations: (state) => state.totalInterations,
    getModulesCount: (state) => state.modulesCount,
    getSessionList: (state) => state.sessionList,
    getSessionDuration: (state) => state.selectedDuration,
    getQnAList: (state) => state.qnaList,
    getLanguageCount: (state) => state.languageCount,
  },
  mutations: {
    //Analytics Newer Version
    setTotalSessions(state, sessionCount) {
      state.totalSessions = sessionCount;
    },
    setTotalInteractions(state, interationCount) {
      state.totalInterations = interationCount;
    },
    setModulesCount(state, modulesCount) {
      state.modulesCount = modulesCount;
    },
    setSessionList(state, list) {
      state.sessionList = list;
    },
    setQnAList(state, list) {
      state.qnaList = list;
    },
    setLanguageCount(state, langCount) {
      state.languageCount = langCount;
    },
    setSessionDuration(state, duration) {
      state.selectedDuration = duration;
    },
    setSelectedKioskAnalytics(state, appId) {
      state.selectedKioskAnalytics = appId;
    },

    setSelectedDuration(state, duration) {
      state.selectedDuration = duration;
    },
    setPieChartTotal(state, total) {
      state.pieChartTotal = total;
    },
    setSingleDatePicker(state, status) {
      state.singleDatePicker = status;
    },
    setSelectedSingleDate(state, date) {
      state.selectedSingleDate = date;
    },
    setWeekDatePicker(state, status) {
      state.weekDatePicker = status;
    },
    setSelectedWeekDate(state, dates) {
      state.selectedWeekDate = dates;
    },
    setDisplayDate(state, dateString) {
      state.displayDate = dateString;
    },
    setFiscalYearPicker(state, status) {
      state.fiscalYearPicker = status;
    },
    setEnteredFiscalYear(state, year) {
      state.enteredFiscalYear = year;
    },
    setcloseWithoutSelection(state, value) {
      state.closeWithoutSelection = value;
    },
    setYearPicker(state, status) {
      state.yearPicker = status;
    },
    setEnteredYear(state, year) {
      state.enteredYear = year;
    },
    resetPieChart(state) {
      state.pieChart = [
        { label: "Faqs", value: 0 },
        { label: "Maps", value: 0 },
        { label: "Forms", value: 0 },
        { label: "Payments", value: 0 },
        { label: "Hearings", value: 0 },
      ];
    },
    resetLanguageBarChart(state) {
      state.languageBarChart = [
        { category: "English", value: 0 },
        { category: "Spanish", value: 0 },
      ];
    },
    resetTodayBarChart(state) {
      state.todayBarChart = [
        { category: "8 AM", value: 0 },
        { category: "9 AM", value: 0 },
        { category: "10 AM", value: 0 },
        { category: "11 AM", value: 0 },
        { category: "12 PM", value: 0 },
        { category: "1 PM", value: 0 },
        { category: "2 PM", value: 0 },
        { category: "3 PM", value: 0 },
        { category: "4 PM", value: 0 },
        { category: "5 PM", value: 0 },
      ];
    },
  },
  actions: {
    async fetchModuleAnalytics({ getters, commit }, data) {
      console.log("Data at Module Analytics: ", process.env.VUE_APP_ANALYTICS_API);
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: process.env.VUE_APP_ANALYTICS_API + "/analytics/modules",
        headers: {
          "x-api-key": process.env.VUE_APP_API_KEY,
          "Content-Type": "application/json",
        },
        data: data,
      };
      console.log("Config at the modules API: ", config)
      const response = await axios.request(config);

      console.log("Response from the Modules API: ", response.data);

      const result = (response.data.data || []).map((m) => ({
        module: m.module,
        total: (m.interactionsInsideModule || 0) + (m.navigationToModule || 0),
      }));

      console.log("Data for the modules: ", result);
      commit("setModulesCount", result);

      return response.data;
    },

    async fetchSessionAnalytics({ commit }, data) {
      let config1 = {
        method: "post",
        maxBodyLength: Infinity,
        url: process.env.VUE_APP_ANALYTICS_API + "/analytics/sessions",
        headers: {
          "x-api-key": process.env.VUE_APP_API_KEY,
          "Content-Type": "application/json",
        },
        data: data,
      };
      const response = await axios.request(config1);

      const totals = (response.data.data || []).reduce(
        (acc, item) => {
          acc.totalSessions += item.sessionCount || 0;
          acc.totalInteractions += item.interactionCount || 0;
          return acc;
        },
        { totalSessions: 0, totalInteractions: 0 }
      );

      console.log("Session totals:", totals);

      commit("setSessionDuration", {
        duration: response.data.duration,
        startDateUTC: response.data.startDate,
        endDateUTC: response.data.endDate,
      });

      commit("setTotalSessions", totals.totalSessions);
      commit("setTotalInteractions", totals.totalInteractions);

      return response.data;
    },

    async fetchQnAAnalytics({ getters, commit }, data) {
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: process.env.VUE_APP_ANALYTICS_API + "/analytics/qna",
        headers: {
          "x-api-key": process.env.VUE_APP_API_KEY,
          "Content-Type": "application/json",
        },
        data: data,
      };
      const response = await axios.request(config);

      console.log("Response from the QNA API: ", response.data);
      commit("setQnAList", response.data);

      return response.data;
    },

    async fetchLanguagesAnalytics({ getters, commit }, data) {
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: process.env.VUE_APP_ANALYTICS_API + "/analytics/languages",
        headers: {
          "x-api-key": process.env.VUE_APP_API_KEY,
          "Content-Type": "application/json",
        },
        data: data,
      };
      const response = await axios.request(config);

      console.log("Response from the Languages API: ", response.data);
      commit("setLanguageCount", response.data);

      return response.data;
    },
    async fetchSessionUseAnalytics({ getters, commit }, data) {
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: process.env.VUE_APP_ANALYTICS_API + "/analytics",
        headers: {
          "x-api-key": process.env.VUE_APP_API_KEY,
          "Content-Type": "application/json",
        },
        data: data,
      };
      const response = await axios.request(config);

      console.log("Response from the Session Use API: ", response.data);
      if(response.data.duration.type === 'Today' || response.data.duration.type === 'Yesterday') {
        commit("setDisplayDate", moment(response.data.endDate).format("MM/DD/YYYY"))
      }else{
        commit("setDisplayDate",  moment(response.data.startDate).format("MM/DD/YYYY") + "-" +  moment(response.data.endDate).format("MM/DD/YYYY"))
      }
      //commit("setDisplayDate", response.data.startDate + "-" + response.data.endDate)
      commit("setSessionList", response.data);

      return response.data;
    },
    async getKioskAnalytics({ commit, getters, dispatch }, duration) {
      console.log("API-Key: ", process.env.VUE_APP_API_KEY);
      console.log(
        "Application Id: ",
        getters.getSelectedKioskAnalytics.applicationId
      );
      const applicationId = getters.getSelectedKioskAnalytics.applicationId;

      // const modules = [...getters.getSelectedKioskAnalytics.modules];
      // console.log("Modules: ", modules);
      // const capitalized = modules.map(
      //   (m) => m.charAt(0).toUpperCase() + m.slice(1)
      // );
      try {
        await dispatch("fetchModuleAnalytics", {
          applicationId,
          duration: duration,
          modules: getters.getSelectedKioskAnalytics.modules,
        });

        await dispatch("fetchSessionAnalytics", {
          applicationId,
          duration: duration,
        });

        await dispatch("fetchQnAAnalytics", {
          applicationId,
          duration: duration,
        });

        await dispatch("fetchLanguagesAnalytics", {
          applicationId,
          duration: duration,
          languages: ["Spanish"], // can be dynamic
        });

        await dispatch("fetchSessionUseAnalytics", {
          applicationId,
          duration: duration,
        });

        return true;
      } catch (err) {
        console.log("getKioskAnalytics failed at some step:", err);
        throw err;
      }
    },
    createTodayBarChart({ getters, commit }, usersessionList) {
      usersessionList.forEach((session) => {
        let day = moment(session.sessionEndTime).format("H");
        switch (day) {
          case "8":
            var eight = getters.todayBarChart.find(
              (item) => item.category === "8 AM"
            );
            eight.value = eight.value + 1;
            break;
          case "9":
            var nine = getters.todayBarChart.find(
              (item) => item.category === "9 AM"
            );
            nine.value = nine.value + 1;
            break;
          case "10":
            var ten = getters.todayBarChart.find(
              (item) => item.category === "10 AM"
            );
            ten.value = ten.value + 1;
            break;
          case "11":
            var eleven = getters.todayBarChart.find(
              (item) => item.category === "11 AM"
            );
            eleven.value = eleven.value + 1;
            break;
          case "12":
            var twelve = getters.todayBarChart.find(
              (item) => item.category === "12 PM"
            );
            twelve.value = twelve.value + 1;
            break;
          case "13":
            var thirteen = getters.todayBarChart.find(
              (item) => item.category === "1 PM"
            );
            thirteen.value = thirteen.value + 1;
            break;
          case "14":
            var fourteen = getters.todayBarChart.find(
              (item) => item.category === "2 PM"
            );
            fourteen.value = fourteen.value + 1;
            break;
          case "15":
            var fifteen = getters.todayBarChart.find(
              (item) => item.category === "3 PM"
            );
            fifteen.value = fifteen.value + 1;
            break;
          case "16":
            var sixteen = getters.todayBarChart.find(
              (item) => item.category === "4 PM"
            );
            sixteen.value = sixteen.value + 1;
            break;
          case "17":
            var seventeen = getters.todayBarChart.find(
              (item) => item.category === "5 PM"
            );
            seventeen.value = seventeen.value + 1;
            break;
        }
      });
    },
    createPieChart({ getters, commit }, usersessionList) {
      commit("resetPieChart");
      usersessionList.forEach((session) => {
        const data = JSON.parse(session.userSession);

        var faq = getters.pieChart.find((item) => item.label === "Faqs");
        faq.value =
          faq.value +
          data.filter(
            (item) => item.response === "faqs" || item.action === "Show Faq"
          ).length;

        var form = getters.pieChart.find((item) => item.label === "Forms");
        form.value =
          form.value +
          data.filter(
            (item) => item.response === "forms" || item.action === "Show Form"
          ).length;

        var map = getters.pieChart.find((item) => item.label === "Maps");
        map.value =
          map.value +
          data.filter(
            (item) => item.response === "maps" || item.action === "View Map"
          ).length;

        var pay = getters.pieChart.find((item) => item.label === "Payments");
        pay.value =
          pay.value +
          data.filter((item) => item.response === "payments").length;

        var hearing = getters.pieChart.find(
          (item) => item.label === "Hearings"
        );
        hearing.value =
          hearing.value +
          data.filter((item) => item.response === "todayshearing").length;
        commit(
          "setPieChartTotal",
          faq.value + form.value + map.value + pay.value + hearing.value
        );
      });
    },
    createLanguageBarChart({ getters }, usersessionList) {
      usersessionList.forEach((session) => {
        const data = JSON.parse(session.userSession);
        var english = getters.languageBarChart.find(
          (item) => item.category === "English"
        );
        english.value = usersessionList.length;

        var spanish = getters.languageBarChart.find(
          (item) => item.category === "Spanish"
        );
        spanish.value =
          spanish.value +
          data.filter((item) => item.response === "Language changed to Spanish")
            .length;
      });
    },

    pullTelepresenceCalls({ commit }, selector) {
      console.log("Incoming Date: ", selector);
      fb.telepresenceCollection
        .where("startTime", ">=", new Date(selector.start))
        .where("startTime", "<=", new Date(selector.end))
        .get()
        .then((snapshot) => {
          if (snapshot.empty) {
            console.log("No Telepresence Calls");
            return;
          }
          snapshot.forEach((doc) => {
            console.log("Telepresence Call: ", doc.data());
          });
        });
    },
  },
};
